// Back-in-Stock (BIS) module.
// Renders behavior for snippets/gc-bis.liquid. The selected variant is owned by
// gc-main.js, which publishes `gc:variant:change` (detail = the variant object).
// This module only subscribes to that event — it does NOT compute the current
// variant itself — which is what keeps BIS in sync across variants.
(function () {
  function init() {
    var wrap = document.querySelector('[data-gc-bis-wrap]');
    var modal = document.querySelector('[data-gc-bis-modal]');
    if (!wrap || !modal) return;

    var trigger = wrap.querySelector('[data-gc-bis-trigger]');
    var jsonEl = document.querySelector('script[data-product-json]');
    var variantInput = document.querySelector('input[name="id"][data-variant-id]');
    var modalClose = modal.querySelector('[data-gc-bis-close]');
    var modalEmail = modal.querySelector('[data-gc-bis-email]');
    var modalSubmit = modal.querySelector('[data-gc-bis-submit]');
    var modalStatus = modal.querySelector('[data-gc-bis-status]');
    var modalCopy = modal.querySelector('[data-gc-bis-copy]');
    if (!trigger || !jsonEl || !variantInput || !modalClose || !modalEmail || !modalSubmit || !modalStatus) return;

    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var variants = (product && product.variants) || [];
    var accountId = wrap.getAttribute('data-account-id') || 'RNZc3Z';
    var revision = wrap.getAttribute('data-revision') || '2024-06-15';

    var current = null;

    function findById(id) {
      var sid = String(id || '');
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === sid) return variants[i];
      }
      return null;
    }

    function variantLabel(v) {
      return v && v.title && v.title !== 'Default Title' ? v.title : null;
    }

    function copyFor(v) {
      var label = variantLabel(v);
      return label
        ? "We'll email you when " + label + " is back in stock."
        : "We'll email you when this item is back in stock.";
    }

    function setStatus(msg, cls) {
      modalStatus.textContent = msg;
      modalStatus.className = 'gc-bis-modal__status' + (cls ? ' ' + cls : '');
    }

    // React to the selected variant: show/hide the trigger by per-variant
    // availability and keep the modal copy + subscribe target accurate.
    function render(v) {
      if (!v) return;
      current = v;
      trigger.setAttribute('data-variant-id', v.id);
      wrap.classList.toggle('is-hidden', !!v.available);
      if (modalCopy) modalCopy.textContent = copyFor(v);
      if (v.available) closeModal();
    }

    function openModal() {
      if (!current) return;
      modal.hidden = false;
      setStatus('', '');
      window.setTimeout(function () { modalEmail.focus(); }, 0);
    }

    function closeModal() {
      modal.hidden = true;
      setStatus('', '');
    }

    function subscribe() {
      var v = current;
      var email = modalEmail.value.trim();
      if (!v) return;
      if (!email) { setStatus('Email is required.', 'is-error'); return; }

      modalSubmit.disabled = true;
      setStatus('Submitting...', '');

      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(accountId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': revision },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { email: email } } },
              channels: ['EMAIL']
            },
            relationships: {
              variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + v.id } }
            }
          }
        })
      }).then(function (response) {
        return response.text().then(function (raw) {
          var data = null;
          try { data = JSON.parse(raw); } catch (_) {}
          if (!response.ok) {
            throw new Error(
              (data && data.errors && data.errors[0] && data.errors[0].detail) ||
              (data && data.detail) ||
              'Unable to submit back in stock request.'
            );
          }
          trackRequest(email, v);
          setStatus('You are on the list. We will email you when it is back in stock.', 'is-success');
          window.setTimeout(closeModal, 1400);
        });
      }).catch(function (error) {
        setStatus(error && error.message ? error.message : 'Unable to submit back in stock request.', 'is-error');
      }).then(function () {
        modalSubmit.disabled = false;
      });
    }

    // Best-effort visibility event: lets the owner see count / who / which
    // variant from inside Klaviyo (metric "Requested Back in Stock").
    // Never blocks or fails the subscription above.
    function trackRequest(email, v) {
      try {
        var price = (typeof v.price === 'number') ? (v.price / 100).toFixed(2) : String(v.price);
        var properties = {
          ProductTitle: product.title,
          ProductHandle: product.handle,
          VariantTitle: variantLabel(v) || 'Default',
          VariantID: String(v.id),
          Price: price,
          URL: window.location.origin + '/products/' + product.handle + '?variant=' + v.id
        };
        fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(accountId), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': revision },
          body: JSON.stringify({
            data: {
              type: 'event',
              attributes: {
                metric: { data: { type: 'metric', attributes: { name: 'Requested Back in Stock' } } },
                profile: { data: { type: 'profile', attributes: { email: email } } },
                properties: properties
              }
            }
          })
        }).catch(function () {});
      } catch (_) {}
    }

    trigger.addEventListener('click', function (e) { e.preventDefault(); openModal(); });
    modalClose.addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    modalSubmit.addEventListener('click', subscribe);
    modalEmail.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); subscribe(); }
      if (e.key === 'Escape') closeModal();
    });

    // Single source of truth — gc-main.js owns "current variant".
    document.addEventListener('gc:variant:change', function (e) { render(e.detail); });

    // Initial state from the server-rendered hidden input.
    render(findById(variantInput.value));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
